import _isEmpty from 'lodash/isEmpty'
import { FlipIntent } from 'cube'
import { Places } from '../RouteConsts'
import { MainKey } from '../main/main.key'
import { ParamIds } from '@/modules/RouteConsts'
import { DateUtils } from 'bula-certa-commons/lang'

export class AnaliseReacoesKey extends MainKey {

    get place() {
        return Places.analiseReacoes
    }

    // :: Property hasData

    get temDados() {
        return this._intent.getParameterAsString(ParamIds.analiseReacoesTemDados) === '1'
    }

    set temDados(v: boolean) {
        this._intent.setParameter(ParamIds.analiseReacoesTemDados, v ? 1 : null)
    }

    // :: Property dataInicial

    get dataInicial(): Date | undefined {
        return parseDate(this._intent, ParamIds.analiseReacoesDtInicial)
    }

    set dataInicial(v: Date | null | undefined) {
        updateDate(this._intent, ParamIds.analiseReacoesDtInicial, v)
    }

    // :: Property dataFinal

    get dataFinal(): Date | undefined {
        return parseDate(this._intent, ParamIds.analiseReacoesDtFinal)
    }

    set dataFinal(v: Date | null | undefined) {
        updateDate(this._intent, ParamIds.analiseReacoesDtFinal, v)
    }

    // :: Busca Geral

    get buscaGeralText() {
        return this._intent.getParameterAsString(ParamIds.analiseReacoesBuscaGeral)
    }

    set buscaGeralText(v: string | undefined | null) {
        this._intent.setParameter(ParamIds.analiseReacoesBuscaGeral, v)
    }

    // :: Busca Reacoes

    get buscaReacaoText() {
        return this._intent.getParameterAsString(ParamIds.analiseReacoesBuscaReacoes)
    }

    set buscaReacaoText(v: string | undefined | null) {
        this._intent.setParameter(ParamIds.analiseReacoesBuscaReacoes, v)
    }

    // :: Busca Medicamentos

    get buscaMedicamentoText() {
        return this._intent.getParameterAsString(ParamIds.analiseReacoesBuscaMedicamentos)
    }

    set buscaMedicamentoText(v: string | undefined | null) {
        this._intent.setParameter(ParamIds.analiseReacoesBuscaMedicamentos, v)
    }

    // :: Status da Bula

    get statusBula() {
        return this._intent.getParameterAsNumber(ParamIds.analiseReacoesStatusBula)
    }

    set statusBula(v: number | undefined | null) {
        this._intent.setParameter(ParamIds.analiseReacoesStatusBula, v === 0 ? null : v)
    }

    // :: Gravidade

    get gravidade() {
        return this._intent.getParameterAsNumber(ParamIds.analiseReacoesGravidade)
    }

    set gravidade(v: number | undefined | null) {
        this._intent.setParameter(ParamIds.analiseReacoesGravidade, v === 0 ? null : v)
    }

}

// :: Utils

function parseDate(intent: FlipIntent, name: string): Date | undefined {
    const v = intent.getParameterAsString(name)
    return v ? DateUtils.parseIsoDate(v) : undefined
}

function updateDate(intent: FlipIntent, name: string, v: Date | null | undefined) {
    let data = v ? v.toISOString().substring(0, 10) : null
    intent.setParameter(name, data)
}